import Http from "../../http/client";
import { RequestQueryBuilder } from "@nestjsx/crud-request";

export default async ({plate,vin, userId, perPage, page}) => {
  const qb = RequestQueryBuilder.create();

  if(plate) { qb.setFilter({ field: "plate", operator: "$starts", value: plate }) }
  if(vin) { qb.setFilter({ field: "vin", operator: "$starts", value: vin }) }
  if(userId) { qb.setFilter({ field: "users.id", operator: "$eq", value: userId }) }

  qb.sortBy({field: 'createdAt', order: "DESC"});

  qb.setPage(page);
  qb.setLimit(perPage);
  qb.setOffset(perPage * page);
  qb.setJoin({field: 'model', select: ['name', 'manufacturer', 'level', 'category']});
  qb.setJoin({field: 'model.manufacturer', select: ['name']});
  qb.setJoin({field: 'users'});

  const response = await Http.get('admin/vehicles', {
    params: qb.queryObject
  });

  return response.data;
}
